import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => {
    const expired = () => setUser((prev) => {
      if (prev) {
        sessionStorage.setItem("tn_session_expired", "1");
        sessionStorage.setItem("tn_return_to", window.location.pathname + window.location.search);
      }
      return false;
    });
    const onVisible = () => { if (document.visibilityState === "visible") api.get("/auth/me").catch(() => {}); };
    window.addEventListener("auth:expired", expired);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("auth:expired", expired);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    sessionStorage.removeItem("tn_session_expired");
    sessionStorage.removeItem("tn_return_to");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
